(() => {
  const init = (scope = document) => scope.querySelectorAll('[id^="SLProduct-"]').forEach(section => {
    if (section.dataset.enhanced) return;
    const source = section.querySelector('[data-slx-variants]');
    if (!source) return;
    section.dataset.enhanced = 'true';
    const variants = JSON.parse(source.textContent);
    const select = section.querySelector('[name="id"]');
    const price = section.querySelector('.slx-product-price');
    const buy = section.querySelector('.slx-atc');
    const labels = section.querySelector('[data-slx-labels]').dataset;
    const fields = [...section.querySelectorAll('.slx-options fieldset')];
    const panels = [...section.querySelectorAll('.slx-product-media')].filter(p => p.querySelector('img'));
    const thumbs = section.querySelector('.slx-thumbnails');
    const zoom = section.querySelector('.slx-zoom-button');
    const dialog = section.querySelector('dialog');
    let active = 0;
    function show(index) {
      active = Math.max(0, index);
      panels.forEach((p, i) => p.hidden = i !== active);
      [...thumbs.children].forEach((b, i) => b.setAttribute('aria-pressed', String(i === active)));
    }
    panels.forEach((panel, index) => {
      const img = panel.querySelector('img');
      const button = document.createElement('button'); button.type = 'button';
      button.setAttribute('aria-label', `${labels.view} ${index + 1}: ${img.alt}`);
      const thumb = img.cloneNode(); thumb.removeAttribute('fetchpriority'); thumb.loading = 'lazy'; thumb.sizes = '80px';
      button.append(thumb); button.addEventListener('click', () => show(index)); thumbs.append(button);
    });
    if (panels.length) { show(Math.max(0, panels.findIndex(panel => !panel.hidden))); zoom.hidden = false; }
    zoom.addEventListener('click', () => {
      const img = panels[active].querySelector('img'); const large = dialog.querySelector('img');
      large.src = img.currentSrc || img.src; large.alt = img.alt; dialog.showModal();
    });
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    function update(changeImage = true) {
      const options = fields.map(f => f.querySelector('input:checked')?.value);
      const variant = variants.find(v => v.options.every((value, i) => value === options[i]));
      if (variant) { select.value = String(variant.id); price.textContent = variant.price; }
      buy.disabled = !variant?.available;
      buy.textContent = variant ? (variant.available ? labels.add : labels.sold) : labels.unavailable;
      const url = new URL(location.href);
      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
      history.replaceState({}, '', url);
      if (variant && changeImage) {
        const colorField = fields.find(f => /colou?r/i.test(f.querySelector('legend').textContent));
        const color = colorField?.querySelector('input:checked')?.value.toLowerCase();
        let index = panels.findIndex(p => p.dataset.editorialColor === color);
        if (index < 0) index = panels.findIndex(p => p.dataset.mediaId === String(variant.media));
        if (index < 0 && color) index = panels.findIndex(p => new RegExp(`\\b${color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i').test(p.dataset.alt || ''));
        if (index >= 0) show(index);
      }
    }
    if (fields.length && select) {
      const initial = variants.find(v => String(v.id) === select.value) || variants[0];
      fields.forEach((f, i) => {
        f.querySelectorAll('input').forEach(input => input.checked = input.value === initial.options[i]);
        f.addEventListener('change', () => update(/colou?r/i.test(f.querySelector('legend').textContent)));
      });
      section.querySelector('.slx-options').hidden = false;
      section.querySelectorAll('[data-variant-fallback]').forEach(el => el.hidden = true);
      update();
    }
    section.querySelector('[data-sl-fit-link]')?.addEventListener('click', () => section.querySelector('[data-sl-fit]').open = true);
    section.querySelector('[data-sl-share]')?.addEventListener('click', async event => {
      const url = event.currentTarget.dataset.url;
      try { if (navigator.share) await navigator.share({title:document.title,url}); else await navigator.clipboard.writeText(url); }
      catch (_) { /* Dismissal leaves the product page unchanged. */ }
    });
  });
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();

